/**
 * @fileoverview Demo scenario registry (mirrors walkthrough-registry pattern)
 */

import type { DemoScenarioDefinition, DemoScenarioId } from './types';

const registry = new Map<DemoScenarioId, DemoScenarioDefinition>();

export function registerDemoScenario<TData>(
  definition: DemoScenarioDefinition<TData>,
): void {
  registry.set(definition.id, definition as DemoScenarioDefinition);
}

export function getDemoScenario(id: DemoScenarioId): DemoScenarioDefinition | undefined {
  return registry.get(id);
}

export function getAllDemoScenarios(): DemoScenarioDefinition[] {
  return Array.from(registry.values());
}

export function hasDemoScenario(id: DemoScenarioId): boolean {
  return registry.has(id);
}
